import { render, staticRenderFns } from "./NavHeading.vue?vue&type=template&id=06414510"
import script from "./NavHeading.vue?vue&type=script&lang=js"
export * from "./NavHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports